var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.453 3.125c-3.425 0-6.397 2.273-7.6 5.551a.875.875 0 0 1-1.643-.602c1.428-3.892 5.006-6.699 9.243-6.699 3.43 0 6.428 1.84 8.204 4.604V2.25a.875.875 0 1 1 1.75 0v6.125a.875.875 0 0 1-.875.875H13.406a.875.875 0 1 1 0-1.75h4.118c-1.42-2.633-4.072-4.375-7.07-4.375zM2.906 19.75v-3.728c1.775 2.764 4.774 4.603 8.204 4.603 4.237 0 7.815-2.807 9.243-6.699a.875.875 0 0 0-1.643-.602c-1.203 3.278-4.175 5.551-7.6 5.551-3 0-5.651-1.742-7.072-4.375h4.118a.875.875 0 0 0 0-1.75H2.031a.875.875 0 0 0-.875.875v6.125a.875.875 0 0 0 1.75 0z",
    fill: "#8A8DAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.dd6248b1057bea1b0b67242feaa3dfc4.svg";
export { ForwardRef as ReactComponent };